import { useMemo } from "react";

const frequencyToMonths = {
  Monthly: 1,
  Quarterly: 3,
  SemiAnnual: 6,
  Annual: 12,
};

const useReportData = (funds) => {
  const calculateNextDeadline = (date, frequency) => {
    const monthsToAdd = frequencyToMonths[frequency] || 0;
    const nextDate = new Date(date);
    nextDate.setMonth(nextDate.getMonth() + monthsToAdd);
    return nextDate;
  };

  return useMemo(() => {
    const reportGeneration = {}; // Track reports to be generated
    const upcomingDeadlines = [];

    funds.forEach((fund) => {
      if (fund.factSheet && Array.isArray(fund.factSheet.reports)) {
        fund.factSheet.reports.forEach((report) => {
          const nextDeadline = report.date
            ? calculateNextDeadline(report.date, fund.navFrequency)
            : null;

          // Populate reports to be generated
          if (!reportGeneration[report.category]) {
            reportGeneration[report.category] = { total: 0, overdue: 0 };
          }
          reportGeneration[report.category].total += 1;
          if (nextDeadline && new Date(nextDeadline) < new Date()) {
            reportGeneration[report.category].overdue += 1;
          }

          // Populate upcoming deadlines
          if (nextDeadline) {
            upcomingDeadlines.push({
              name: report.name,
              fundName: fund.fundName,
              deadline: nextDeadline,
              status: report.status,
            });
          }
        });
      }
    });

    // Sort deadlines by date
    const sortedDeadlines = upcomingDeadlines.sort(
      (a, b) => new Date(a.deadline) - new Date(b.deadline)
    );

    return { reportGeneration, upcomingDeadlines: sortedDeadlines };
  }, [funds]);
};

export default useReportData;
